/**
 * Japan military-base and restricted facility names.
 * Used for client-side shipping address blocking (autocomplete + form validation).
 */
export const JAPAN_BLOCKED_ADDRESSES = [
  '千歳キャンプ',
  'Camp Chitose',
  '東千歳駐屯地',
  'East Chitose Garrison',
  '千歳演習場',
  'Chitose Training Area',
  '別海矢臼別大演習場',
  'Betsukai Yausubetsu Training Area',
  '釧路駐屯地',
  'Kushiro Garrison',
  '鹿追駐屯地',
  'Shikaoi Garrison',
  '上富良野中演習場',
  'Kamifurano Central Training Area',
  '札幌駐屯地',
  'Sapporo Garrison',
  '鹿追燃別中演習場',
  'Shikaoi Nobetsu Central Training Area',
  '帯広駐屯地',
  'Obihiro Garrison',
  '旭川近文台演習場',
  'Asahikawa Kinbun Training Area',
  '丘珠駐屯地',
  'Okadama Garrison',
  '名寄演習場',
  'Nayoro Training Area',
  '滝川演習場',
  'Takikawa Training Area',
  '美幌訓練場',
  'Bihoro Training Area',
  '俱知安高嶺演習場',
  'Kutchan Takamine Training Area',
  '遠軽演習場',
  'Engaru Training Area',
  '三沢対地射爆擊場',
  'Misawa Bombing Range',
  '八戸貯油施設',
  'Hachinohe Fuel Depot',
  '八戸駐屯地',
  'Hachinohe Garrison',
  '青森小谷演習場',
  'Aomori Kodani Training Area',
  '弘前演習場',
  'Hirosaki Training Area',
  '車力通信所',
  'Shariki Communication Site',
  '岩手岩手山中演習場',
  'Iwate Iwateyama Training Area',
  '仙台駐屯地',
  'Sendai Garrison',
  '大和王城寺原大演習場',
  'Yamato Ojojihara Training Area',
  '霞の目飛行場',
  'Kasuminome Airfield',
  '神町大高根演習場',
  'Jinmachi Otakane Training Area',
  '赤坂プレス・センター',
  'Akasaka Press Center',
  '府中通信施設',
  'Fuchu Communication Site',
  '多摩サービス補助施設',
  'Tama Service Annex',
  '由木通信所',
  'Yugi Communication Site',
  '所沢通信施設',
  'Tokorozawa Communication Site',
  '朝霞キャンプ',
  'Camp Asaka',
  '朝瓜駐屯地',
  'Asaka Garrison',
  '硫黄島通信所',
  'Iwo Jima Communication Site',
  'ニューサンノ一米軍センター',
  'New Sanno U.S. Military Center',
  '横田飛行場',
  'Yokota Air Base',
  '大和田通信所',
  'Owada Communication Site',
  '相馬原演習場',
  'Soma-hara Training Area',
  '木更津飛行場',
  'Kisarazu Airfield',
  '高田関山演習場',
  'Takada Sekiyama Training Area',
  '根岸住宅地区',
  'Negishi Housing Area',
  '横浜ノース・ドック',
  'Yokohama North Dock',
  '上瀬谷通信施設',
  'Kami-Seya Communication Facility',
  '鶴見貯油施設',
  'Tsurumi Fuel Depot',
  '横須賀海軍施設',
  'Yokosuka Naval Base',
  '吾妻倉庫地区',
  'Azuma Storage Area',
  '浦鄉倉庫地区',
  'Uraga Storage Area',
  '長坂小銃射擊場',
  'Nagasaka Rifle Range',
  '池子住宅地区及び海軍補助施設',
  'Ikego Housing Area and Navy Annex',
  '相模原住宅地区',
  'Sagamihara Housing Area',
  '相模総合補給廠',
  'Sagamihara Depot',
  '厚木海軍飛行場',
  'Atsugi Naval Air Facility',
  '座間キャンプ',
  'Camp Zama',
  '富士演習場',
  'Fuji Training Area',
  '富士営舎地区',
  'Fuji Garrison Area',
  '沼津海浜訓練場',
  'Numazu Seaside Training Area',
  '滝原駐屯地',
  'Takihara Garrison',
  '今津饗庭野中演習場',
  'Imazu Aibano Central Training Area',
  '伊丹駐屯地',
  'Itami Garrison',
  '呉第6突堤',
  'Kure Pier 6',
  '灰ヶ峰通倍施設',
  'Haigamine Tobai Facility',
  '広弾薬庫',
  'Hiro Ammunition Depot',
  '川上弹藥庫',
  'Kawakami Ammunition Depot',
  '秋月弹粟庫',
  'Akizuki Ammunition Depot',
  '第一術科学校訓練施設',
  'First Technical School Training Facility',
  '原村演習場',
  'Haramura Training Area',
  '祖生通信所',
  'Suo Communication Site',
  '日本原中演習場',
  'Nihonbara Central Training Area',
  '経ヶ岬通信所',
  'Kyogamisaki Communication Site',
  '背振山通信施設',
  'Sefuri Communication Facility',
  '佐築城飛行場',
  'Satsuki Castle Airfield',
  '対馬通信所',
  'Tsushima Communication Site',
  '崎辺小銃射撃場',
  'Sakibe Rifle Range',
  '崎辺海軍補助施設',
  'Sakibe Naval Annex',
  '針尾住宅地区大村飛行場',
  'Hario Housing Area / Omura Air Base',
  '日出生台・十文字原演習場',
  'Hitenodai / Jummonjibaru Training Area',
  '新田原飛行場',
  'Nyutabaru Air Base',
  '大矢野原•霧島演習場',
  'Oyano-Kirishima Training Area',
  '佐世保ドライ・ドック地区',
  'Sasebo Dry Dock Area',
  '佐世保弹藥補給所',
  'Sasebo Ammunition Depot',
  '針尾島弹藥集積所',
  'Hario Island Ammunition Depot',
  '北熊本駐屯地',
  'North Kumamoto Garrison',
  '健軍駐屯地',
  'Kengun Garrison',
  '北部訓練場',
  'Northern Training Area',
  '奥間レスト・センター',
  'Okuma Rest Center',
  '伊江島補助飛行場',
  'Ie Shima Auxiliary Airfield',
  '八重岳通信所',
  'Yaedake Communication Site',
  'キャンプ・シュワブ',
  'Camp Schwab',
  '辺野古弾薬庫',
  'Henoko Ammunition Depot',
  'キャンプ・ハンセン',
  'Camp Hansen',
  '金武レッド・ビーチ訓練場',
  'Kin Red Beach Training Area',
  '金武ブルー・ビーチ訓練場',
  'Kin Blue Beach Training Area',
  '嘉手納弾薬庫地区',
  'Kadena Ammunition Storage Area',
  '天願桟橋',
  'Tengan Pier',
  'キャンプ・コートニー',
  'Camp Courtney',
  'キャンプ・マクトリアスキャンプ・シールズ',
  'Camp McTureous / Camp Shields',
  'トリイ通信施設',
  'Torii Communication Station',
  '嘉手納飛行場',
  'Kadena Air Base',
  'キャンプ桑江',
  'Camp Kuwae',
  'キャンプ瑞慶覧',
  'Camp Foster',
  '泡瀬通信施設',
  'Awase Communication Facility',
  'ホワイト・ビーチ地区',
  'White Beach Area',
  '普天問飛行場',
  'Futenma Air Base',
  '牧港補給地区',
  'Makiminato Service Area',
  '那覇港湾施設',
  'Naha Port Facility',
  '陸軍貯油施設',
  'Army Petroleum Depot',
  '鳥島射爆撃場',
  'Torishima Bombing Range',
  '出砂島射爆撃場',
  'Deshima Bombing Range',
  '久米島射爆撃場',
  'Kumejima Bombing Range',
  '津堅島訓練場（浮原島訓練場）',
  'Tsukenjima Training Area',
  '黄尾嶼射熘轚場',
  'Kobi Sho Bombing Range',
  '赤尾嶼射爆擊場',
  'Akao Sho Bombing Range',
  '沖大東島射爆擊場',
  'Okidaitojima Bombing Range',
  'キャンプ',
  'Camp',
  '駐屯地',
  'Garrison',
  '演習場',
  'Training area',
  '擊場',
  'Range',
  '貯油施設',
  'Fuel depot',
  '通信所',
  'Communication site',
  '飛行場',
  'Airfield',
  '通信施設',
  'Service Annex',
  '賀海軍施設',
  'Naval base',
  '倉庫地区',
  'Storage area',
  '総合補給廠',
  'Depot',
  '弾薬',
  'Ammunition',
  '弹藥',
] as const;
